import { getAccessToken } from "../Services/authToken";

export interface NoAlternateSlotsPayload {
  email_type: "interview_reschedule";
  additional_data: {
    candidate_email: string;
    candidate_name: string;
    job_title: string;
    interviewer_slots: Array<{
      interviewer_email: string;
      interviewer_name: string;
      start_time: string | null;
      end_time: string | null;
    }>;
    interview_date: string;
    recruiter_email: string;
    recruiter_name: string;
    reschedule_reason: string;
    send_to_candidate: boolean;
    send_to_interviewers: boolean;
    send_to_recruiter: boolean;
    campus_hire: boolean;
    experienced_hire: boolean;
  };
}

const hostname = window.location.hostname;

export async function sendNoAlternateSlotsEmail(
  emailPayload: NoAlternateSlotsPayload
): Promise<void> {
  let baseurl = "";
  if (hostname.includes("localhost")) {
    baseurl = "http://localhost:8080";
  } else if (hostname.includes("dev")) {
    baseurl = "https://candidateinterviewscheduler-dev.pwc.com";
  } else if (hostname.includes("stg") || hostname.includes("stage")) {
    baseurl = "https://candidateinterviewscheduler-stg.pwc.com";
  } else {
    baseurl = "https://candidateinterviewscheduler.pwc.com"; // fallback
  }

  // GET TOKEN
  const token = await getAccessToken();
  if (!token) {
    throw new Error("Authentication required - please log in");
  }

  console.log("No-alternate-slot email payload:", emailPayload);

  const res = await fetch(`${baseurl}/api/communications/emails`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(emailPayload),
  });

  console.log("Email response:", res);

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`No-slot email failed: ${res.status} ${res.statusText} ${text}`);
  }
}